import { getRequest, urlBuilder } from 'tfs.front-end-utils/requests'

import staticData from '../../config/staticData'

import formatErrors from '../../utils/errors/formatErrors'
import generateAuthorizationHeaders from '../../utils/requests/generateAuthorizationHeaders'
import { customTourOperatorParameters } from '../../utils/tourOperators'

export default async (flightId: string) => {
  const {
    endpoints: {
      flight: { url, headers },
    },
  } = staticData
  const authHeaders = await generateAuthorizationHeaders(headers)

  const fixedUrl = url.endsWith('/') ? url : `${url}/`
  const reqUrl = `${fixedUrl}${flightId}`
  const requestUrl = urlBuilder(reqUrl, customTourOperatorParameters())

  return getRequest(
    requestUrl,
    { headers: { ...headers, ...authHeaders } },
    {},
    formatErrors
  )
}
